var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mainContainer pbottom50"},[_c('div',{staticClass:"title"},[_vm._m(0),_c('p',{staticClass:"pointer",on:{"click":_vm.enterOrderList}},[_vm._v("点我前往")])]),_c('Class')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',[_c('span',{staticStyle:{"font-weight":"bold"}},[_vm._v("学员请注意：")]),_vm._v("缴费后在我的订单中点击”订单详情“自动开课")])
}]

export { render, staticRenderFns }